import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { map, Observable } from 'rxjs';
import {
  LOGIN_URL,
  HOST,
  API_URL,
  FORCE_SECURED_ENDPOINT,
  TOKEN_NORMALIZER,
  WEBSOCKET_PATH_NORMALIZER,
} from './websocket.constant';

@Injectable({ providedIn: 'root' })
export class WebsocketApi {

  #http = inject(HttpClient);
  #loginUrl = inject(LOGIN_URL);
  #host = inject(HOST);
  #apiUrl = inject(API_URL);
  #forceSecuredEndpoint = inject(FORCE_SECURED_ENDPOINT);
  #tokenNormalizerFn = inject(TOKEN_NORMALIZER);
  #pathNormalizer = inject(WEBSOCKET_PATH_NORMALIZER);

  messages$: Observable<any>;

  private _subject$: WebSocketSubject<any>;

  connect(token: string, receiverId: string) {
    this._subject$ = webSocket(this._getConnectEndpoint(token, receiverId));
    this.messages$ = this._subject$.asObservable();
  }

  send(message: any) {
    this._subject$.next(message);
  }

  auth$(accessToken: string) {
    // TODO: make variable...
    return this.#http.post<any>(
      this.#loginUrl,
      { accessToken }
    ).pipe(map((r) => this.#tokenNormalizerFn(r)));
  }

  private _getConnectEndpoint(token: string, receiverId: string) {
    let protocol = window.location.protocol === 'https:'
      ? 'wss'
      : 'ws';

    if (this.#forceSecuredEndpoint) {
      protocol = 'wss';
    }

    let host = this.#host;
    if (!host) {
      host = window.location.hostname;
    }

    const receiverTokenPath = this.#pathNormalizer({ token, receiverId });

    return `${protocol}://${host}${this.#apiUrl ? `/${this.#apiUrl}` : '/api/rest/public/web-socket'}${receiverTokenPath}`;
  }
}
